/**
 * PWA Setup - Register service worker and handle installation
 */

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration.scope)

          // Check for updates
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing
            console.log('Service Worker update found')

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available, show update notification
                showUpdateNotification()
              }
            })
          })
        })
        .catch((error) => {
          console.error('Service Worker registration failed:', error)
        })
    })
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister()
      })
      .catch((error) => {
        console.error('Service Worker unregistration failed:', error)
      })
  }
}

function showUpdateNotification() {
  // You can show a toast/snackbar here
  if (confirm('New version available! Reload to update?')) {
    window.location.reload()
  }
}

/**
 * Check if app is installed as PWA
 */
export function isInstalledPWA() {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone === true
}

/**
 * Show install prompt
 */
let deferredPrompt = null

export function setupInstallPrompt() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferredPrompt = e
    // Show custom install button
    showInstallButton()
  })

  window.addEventListener('appinstalled', () => {
    console.log('PWA installed')
    deferredPrompt = null
    hideInstallButton()
  })
}

export async function showInstallPrompt() {
  if (!deferredPrompt) {
    return false
  }

  deferredPrompt.prompt()
  const { outcome } = await deferredPrompt.userChoice
  console.log(`User ${outcome} the install prompt`)
  deferredPrompt = null

  return outcome === 'accepted'
}

function showInstallButton() {
  const installButton = document.getElementById('pwa-install-button')
  if (installButton) {
    installButton.style.display = 'block'
  }
}

function hideInstallButton() {
  const installButton = document.getElementById('pwa-install-button')
  if (installButton) {
    installButton.style.display = 'none'
  }
}

/**
 * Request notification permission
 */
export async function requestNotificationPermission() {
  if (!('Notification' in window)) {
    return false
  }

  if (Notification.permission === 'granted') {
    return true
  }

  if (Notification.permission !== 'denied') {
    const permission = await Notification.requestPermission()
    return permission === 'granted'
  }

  return false
}

/**
 * Show local notification
 */
export function showNotification(title, options = {}) {
  if (Notification.permission === 'granted') {
    const notification = new Notification(title, {
      icon: '/icons/icon-192x192.png',
      badge: '/icons/icon-72x72.png',
      ...options
    })

    notification.onclick = () => {
      if (options.url) {
        window.open(options.url)
      }
    }

    return notification
  }
}

/**
 * Check online status
 */
export function setupOnlineStatusHandler(onOnline, onOffline) {
  window.addEventListener('online', () => {
    console.log('Back online')
    if (onOnline) onOnline()
  })

  window.addEventListener('offline', () => {
    console.log('Gone offline')
    if (onOffline) onOffline()
  })
}

export function isOnline() {
  return navigator.onLine
}
